/* eslint-disable global-require */
import React from 'react';
import Article from '../../../Components/Article';
import FeaturedContentTwo from '../../../Components/FeaturedContentTwo';
import FeaturedContentCenter from '../../../Components/FeaturedContentCenter';
import Button from '../../../Components/Button';

class EmployersTab extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <FeaturedContentCenter>
          <Article center>
            <header className="article__header" id="exams">
              <h2>Linguaskill for Employers</h2>
            </header>
            <section className="article__section">
              <p>
                If your employees need to work with colleagues or customers around the world in
                English, it is important that you are able to measure and support their
                communication skills.
                <br />
                Two test options are available, Linguaskill General and Linguaskill Business,
                depending on whether the job role requires everyday English or English used in a
                business and corporate setting. Results are fast and accurate, and aligned to
                international standards.
              </p>
            </section>
            <footer className="article__footer">
              <Button as="link" color="red" onClick={() => '#employeeBenefits'}>
                Register your interest
              </Button>
            </footer>
          </Article>
        </FeaturedContentCenter>
        <FeaturedContentTwo color="red" image={require('./image6.jpg')}>
          <Article>
            <header className="article__header">
              <h2>
                <strong>Accurate results you can trust</strong>
              </h2>
            </header>
            <section className="article__section">
              <p>
                Linguaskill has been extensively researched and trialled by speakers of over 40
                languages from 50 countries to ensure the accuracy and reliability of the results.
              </p>
            </section>
          </Article>
        </FeaturedContentTwo>
        <FeaturedContentTwo right color="red" image={require('./image7.jpg')}>
          <Article>
            <header className="article__header" id="exams">
              <h2>Fast results, in-depth reporting</h2>
            </header>
            <section className="article__section">
              <p>
                Results are generated within 48 hours, with instant results for the Reading and
                Listening module. Clear individual Test Reports and Group Reports are provided for
                easy comparison of performance, and the results are aligned to international
                standard measures to allow you to make informed decisions.
              </p>
            </section>
          </Article>
        </FeaturedContentTwo>
        <FeaturedContentTwo color="red" image={require('./image8.jpg')}>
          <Article>
            <header className="article__header">
              <h2>Reliable and easy to administer</h2>
            </header>
            <section className="article__section">
              <p>
                The online test can be easily administered and invigilated at your own venue, at a
                time that suits you. All you need is a computer, internet connection, a microphone
                and headphones. You can test the English level of individuals or groups of
                candidates.
              </p>
            </section>
          </Article>
        </FeaturedContentTwo>
      </React.Fragment>
    );
  }
}
export default EmployersTab;
